<div mat-dialog-content>
    <p><b>Actuals exist for this kaizen account, do you really want to Delete? If you click "Yes" you will delete the actuals.</b></p>
</div>
<div mat-dialog-actions>
    <button  mat-flat-button type="button" color="primary" [mat-dialog-close]="true">Yes</button>
    <button mat-flat-button type="button" color="primary" [mat-dialog-close]="false">No</button>
</div>